<template>
  <v-content>
    <Jumbotron
    @showVideo="isShowVideo=!isShowVideo"
    @showGallery="isShowGallery=!isShowGallery"
    />
    <ProjectsCard/> 
    <BuzzGallery v-if="isShowGallery" @showGallery="isShowGallery=!isShowGallery" :images="gallery"/>
    <BuzzTube v-if="isShowVideo" @showVideo="isShowVideo=!isShowVideo" :videos="videos"/>
  </v-content>
</template>

<script>
import Jumbotron from '@/components/Jumbotron.vue'
import ProjectsCard from '@/components/ProjectsCard.vue'
import BuzzGallery from '@/components/BuzzGallery'
import BuzzTube from '@/components/BuzzTube'
import Api from '@/api'

export default {
  data () {
    return {
      isShowGallery: false,
      gallery: [],
      isShowVideo: false,
      videos: []
    }
  },
  beforeMount () {
    this.getGalleryData()
    this.getVideoData()
  },
  components: {
    Jumbotron,
    ProjectsCard,
    BuzzGallery,
    BuzzTube
  },
  methods: {
    // showVideo () {
    //   // this.$emit('showVideo')
    // },
    getGalleryData () {
      // console.log(projectID)
      const path = '/image-gallery'
      // const auth = {
      //   username: this.authUsername,
      //   password: this.authPassword
      // }
      Api.get(path)
        .then(response => {
          if (response.data.status === 0) {
            // console.log(response.data.imagegallery[0].project_details)
            response.data.imagegallery.forEach((el) => {
              // this.gallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.project.name })
              this.gallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.project.name, 'project_details': el.project_details.headline })
            })
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal({
            'type': 'error',
            'title': error.toString().substring(0, 100)
          })
        })
    },
    getVideoData () {
      const path = '/video-gallery'
      // const auth = {
      //   username: this.authUsername,
      //   password: this.authPassword
      // }
      Api.get(path)
        .then(response => {
          if (response.data.status === 0) {
            this.videos = response.data.videos
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FrontPage.vue